import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';
/**
 * "Keep me signed in for 30 days", unticked by default. Ticked, the sign-in cookie outlives the
 * browser for its full 30 days; unticked, it ends when the browser closes. EU guidance only
 * exempts a sign-in cookie from consent for the session, so staying signed in across browser
 * restarts has to be the user's explicit request; it is also the safer default on a shared
 * clinic workstation. The server honours it on password, MFA and SSO sign-in.
 */
export function KeepSignedInCheckbox({ checked, onCheckedChange, disabled, }) {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "flex items-start gap-2", children: [_jsx(Checkbox, { id: "keep-signed-in", checked: checked, onCheckedChange: (value) => onCheckedChange(value === true), disabled: disabled, className: "mt-0.5", "data-testid": "keep-signed-in" }), _jsxs("div", { className: "grid gap-0.5", children: [_jsx(Label, { htmlFor: "keep-signed-in", className: "text-sm font-normal", children: t('login.keepSignedIn') }), _jsx("p", { className: "text-muted-foreground text-xs", children: t('login.keepSignedInHint') })] })] }));
}
